import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-check-barcode',
  templateUrl: `${environment.pageFolder}/modal-check-barcode.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/modal-check-barcode.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class ModalCheckBarcodeComponent {
  checkBarcodeForm = this.formBuilder.group({
    barcode: ['', [Validators.required, Validators.minLength(5)]],
  });
  errorMessage: string = '';

  @Output() closeModalCheckBarcode = new EventEmitter<void>();
  @Output() validBarcode = new EventEmitter<void>();

  constructor(
    private formBuilder: FormBuilder,
    private services: Services,
    private readonly errorMessageService: ErrorMessageService
  ) {}

  ngOnInit() {}

  closeModalOnClickOutside(event: any) {
    if (event.target.className === 'modal-overlay') {
      this.closeModalCheckBarcode.emit();
    }
  }

  onSubmit(): void {
    if (this.checkBarcodeForm.invalid) {
      this.errorMessage = this.errorMessageService.getErrorMessage('barcodeRequired');
    } else {
      this.errorMessage = '';
      const loader = document.getElementById("loader-container");
      loader!.style.display = "flex";
      const barcode = this.checkBarcodeForm.value.barcode;

      this.services.checkBarcodeService(barcode, false).subscribe(Response => {
        const data = Response;
        if(data.data.isValid) {
          this.validBarcode.emit(data);
        } else {
          this.errorMessage = this.errorMessageService.getErrorMessage('invalidBarcode');
          loader!.style.display = "none";
        }
      })
    }
  }
}